import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

import {
  // ホームはリニューアル予定なのでコメントアウト
  // homePath,
  questionnairePath,
  myDataPath,
  selectMaterialsPath,
  listMaterialPath,
  listActiveLearningPath,
  actionListPath,
  Context,
} from "../../../studentStore";
import { isAvailablePartItemCodes } from "../../../libs/ActiveLearning";
import { ReactComponent as StudentProfileIcon } from "../../../assets/svg/student_profile.svg";
import { ReactComponent as StudentProfileEditIcon } from "../../../assets/svg/student_profile_edit.svg";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/svg/arrow_left_2.svg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/svg/arrow_right_2.svg";
// import { ReactComponent as HomeIcon } from "../../../assets/svg/home-menu_2.svg";
import { ReactComponent as BookIcon } from "../../../assets/svg/book_2.svg";
import { ReactComponent as LogoutIcon } from "../../../assets/svg/logout_2.svg";
import { ReactComponent as QuestionnaireIcon } from "../../../assets/svg/questionnaire.svg";
import { ReactComponent as MyDataIcon } from "../../../assets/svg/class-data_2.svg";
import { ReactComponent as AssessmentIcon } from "../../../assets/svg/assessment_2.svg";
import { ReactComponent as GearIcon } from "../../../assets/svg/gear_2.svg";
import { ReactComponent as ActionListIcon } from "../../../assets/svg/action_list_2.svg";
import { ReactComponent as CloseIcon } from "../../../assets/svg/close_2.svg";
import Modal from "../../../atoms/Modal";
import { STUDENT_SESSION_KEY } from "../../../Definition";

import styles from "./Sidebar.module.scss";

export interface SidebarProps {
  className?: string;
  isLoaded: boolean;
  isDlpEnabled: boolean;
  isSurveyEnabled: boolean;
  isOnlyAssessment: boolean;
  isG4sEnabled: boolean;
  availableItemCodes: string[];
  logout: () => void;
  isOnlyBase: boolean;
  isMasqueradeByTeacher: boolean;
  onProfileClick: () => void;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = props => {
  const { state } = useContext(Context);

  const fullName = state.student
    ? `${state.student.last_name}${state.student.first_name}`
    : "";
  const classNameString = state.class_name || "-";
  const photoUrl = state.student?.photo?.url;

  const [showModal, setShowModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const location = useLocation();
  const path = location.pathname;
  const checkActive = (...args: string[]) => {
    return clsx(args.some(compare => compare === path) && styles.active);
  };
  const extra = sessionStorage.getItem(STUDENT_SESSION_KEY)
    ? `?session_id=${sessionStorage.getItem(STUDENT_SESSION_KEY)}`
    : "";

  return (
    <>
      <div
        className={clsx(
          styles.sidebarWrapper,
          isCollapsed && styles.collapsed,
          props.onClose && styles.fadeInLeftAnimation,
          props.className,
        )}
      >
        <nav className={styles.sidebar}>
          <div className={styles.topSection}>
            <div className={styles.toggleBtnWrapper}>
              <button
                className={styles.toggleBtn}
                onClick={() =>
                  props.onClose ? props.onClose() : setIsCollapsed(!isCollapsed)
                }
              >
                {props.onClose ? (
                  <CloseIcon />
                ) : isCollapsed ? (
                  <ArrowRightIcon />
                ) : (
                  <ArrowLeftIcon />
                )}
              </button>
            </div>

            <div className={styles.profileCard}>
              <div
                className={styles.profileIcon}
                onClick={props.onProfileClick}
              >
                {photoUrl ? (
                  <img
                    src={photoUrl}
                    alt="profile"
                    className={styles.profileImg}
                  />
                ) : (
                  <StudentProfileIcon className={styles.defaultIcon} />
                )}
                <div className={styles.editOverlay}>
                  <StudentProfileEditIcon />
                </div>
              </div>

              <div className={styles.profileInfo}>
                <span className={styles.studentName}>{fullName}</span>
                <span className={styles.studentClass}>{classNameString}</span>
              </div>
            </div>
          </div>
          {props.isLoaded && (
            <ul className={styles.menuList}>
              {!props.isOnlyAssessment && (
                <>
                  {/* <li className={checkActive(homePath)}>
                    <Link
                      to={homePath}
                      className={clsx(
                        styles.menuLink,
                        path === homePath && styles.activeLink,
                      )}
                    >
                      <div className={styles.iconWrapper}>
                        <HomeIcon />
                      </div>
                      <span className={styles.menuText}>HOME</span>
                    </Link>
                  </li> */}
                  <li
                    className={checkActive(
                      selectMaterialsPath,
                      listMaterialPath,
                      listActiveLearningPath,
                    )}
                  >
                    {!props.isDlpEnabled ? (
                      <div className={clsx(styles.menuLink, styles.disabled)}>
                        <div className={styles.iconWrapper}>
                          <BookIcon />
                        </div>
                        <span className={styles.menuText}>教材</span>
                      </div>
                    ) : (
                      <Link
                        to={
                          isAvailablePartItemCodes(props.availableItemCodes)
                            ? selectMaterialsPath
                            : listMaterialPath
                        }
                        className={clsx(
                          styles.menuLink,
                          [
                            selectMaterialsPath,
                            listMaterialPath,
                            listActiveLearningPath,
                          ].some(p => path.includes(p)) && styles.activeLink,
                        )}
                      >
                        <div className={styles.iconWrapper}>
                          <BookIcon />
                        </div>
                        <span className={styles.menuText}>教材</span>
                      </Link>
                    )}
                  </li>
                  {!props.isOnlyBase && (
                    <li className={checkActive(actionListPath)}>
                      <Link
                        to={actionListPath}
                        className={clsx(
                          styles.menuLink,
                          path.includes(actionListPath) && styles.activeLink,
                        )}
                      >
                        <div className={styles.iconWrapper}>
                          <ActionListIcon />
                        </div>
                        <span className={styles.menuText}>行動リスト</span>
                      </Link>
                    </li>
                  )}
                  <li className={checkActive(myDataPath)}>
                    {!props.isDlpEnabled ? (
                      <div className={clsx(styles.menuLink, styles.disabled)}>
                        <div className={styles.iconWrapper}>
                          <MyDataIcon />
                        </div>
                        <span className={styles.menuText}>回答データ</span>
                      </div>
                    ) : (
                      <Link
                        to={myDataPath}
                        className={clsx(
                          styles.menuLink,
                          path.includes(myDataPath) && styles.activeLink,
                        )}
                      >
                        <div className={styles.iconWrapper}>
                          <MyDataIcon />
                        </div>
                        <span className={styles.menuText}>回答データ</span>
                      </Link>
                    )}
                  </li>
                </>
              )}
              {props.isG4sEnabled &&
                !props.isMasqueradeByTeacher &&
                !props.isOnlyAssessment && (
                  <li>
                    <a
                      href={`${process.env.REACT_APP_STUDENT_GEAR_URL}/student/assessment_description${extra}`}
                      target="_blank"
                      rel="noreferrer"
                      className={styles.menuLink}
                    >
                      <div className={styles.iconWrapper}>
                        <AssessmentIcon />
                      </div>
                      <span className={styles.menuText}>自己評価データ</span>
                    </a>
                  </li>
                )}
              {props.isSurveyEnabled && !props.isOnlyAssessment && (
                <li className={checkActive(questionnairePath)}>
                  {!props.isDlpEnabled ? (
                    <div className={clsx(styles.menuLink, styles.disabled)}>
                      <div className={styles.iconWrapper}>
                        <QuestionnaireIcon />
                      </div>
                      <span className={styles.menuText}>アンケート</span>
                    </div>
                  ) : (
                    <Link
                      to={questionnairePath}
                      className={clsx(
                        styles.menuLink,
                        path.includes(questionnairePath) && styles.activeLink,
                      )}
                    >
                      <div className={styles.iconWrapper}>
                        <QuestionnaireIcon />
                      </div>
                      <span className={styles.menuText}>アンケート</span>
                    </Link>
                  )}
                </li>
              )}
            </ul>
          )}
          <div className={styles.bottomSection}>
            {props.isG4sEnabled && !props.isMasqueradeByTeacher && (
              <a
                href={`${process.env.REACT_APP_STUDENT_GEAR_URL}${extra}`}
                target="_blank"
                rel="noreferrer"
                className={styles.gearLink}
              >
                <div className={styles.iconWrapper}>
                  <GearIcon />
                </div>
              </a>
            )}

            <button
              className={styles.logoutBtn}
              onClick={() => setShowModal(true)}
            >
              <div className={styles.iconWrapper}>
                <LogoutIcon />
              </div>
              <span className={styles.menuText}>ログアウト</span>
            </button>
          </div>
        </nav>
      </div>
      {showModal && (
        <Modal
          onClose={() => setShowModal(false)}
          className={styles.modalLogout}
        >
          <div className={styles.modalLogout__title}>ログアウトしますか？</div>
          <div className={styles.modalLogout__actions}>
            <button
              className={styles.btnCancel}
              onClick={() => setShowModal(false)}
            >
              キャンセル
            </button>
            <button className={styles.btnOk} onClick={props.logout}>
              ログアウト
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Sidebar;
